<template>
	<tbody>
		<tr>
			<td>
				<template v-if="editMode">
					<template v-if="user.hasRole('admin')">
						<div class="form-group" :class="{ 'has-error' : errors.has('name') }">
							<input
								v-validate="'required'"
								name="name"
								data-vv-as="Nombre"
								v-model="item.name"
								type="text"
								class="form-control">
							<small v-show="errors.has('name')" class="form-text text-danger">
								{{ errors.first('name') }}
							</small>
						</div>
					</template>
				</template>
				<template v-else>
					{{ item.name }}
				</template>
			</td>
			<td>
				<template v-if="editMode">
					<template v-if="user.hasRole('admin')">
						<div class="form-group" :class="{ 'has-error' : errors.has('value') }">
							<input
								v-validate="'required'"
								name="value"
								data-vv-as="Valor"
								v-model="item.value"
								type="text"
								class="form-control">
							<small v-show="errors.has('value')" class="form-text text-danger">
								{{ errors.first('value') }}
							</small>
						</div>
					</template>
				</template>
				<template v-else>
					{{ item.value }}
				</template>
			</td>
			<td>
				<template v-if="user.hasRole('admin')">
					<div class="btn-group pull-right">
						<template v-if="editMode">
							<button @click="validate" type="button" class="btn btn-success">
								<i class="fa fa-floppy-o" aria-hidden="true"></i>
							</button>
							<button @click="cancel" type="button" class="btn btn-default">
								<i class="fa fa-ban" aria-hidden="true"></i>
							</button>
						</template>
						<template v-else>
							<button @click="editMode = true" type="button" class="btn btn-default">
								<i class="fa fa-pencil-square-o" aria-hidden="true"></i>
							</button>
							<button @click="destroy" type="button" class="btn btn-danger">
								<i class="fa fa-trash" aria-hidden="true"></i>
							</button>
							<template v-if="showImage">
								<template v-if="item.image">
									<button @click="destroyImage" type="button" class="btn btn-danger">
										<i class="fa fa-times" aria-hidden="true"></i>
									</button>
								</template>
							</template>
							<button @click="showImage = !showImage" type="button" class="btn btn-default">
								<i class="fa fa-file-image-o" aria-hidden="true"></i>
							</button>
						</template>
					</div>
				</template>
			</td>
		</tr>
		<tr v-if="showImage">
			<td colspan="3">
				<template v-if="item.image">
					<img :src="item.image" class="img-responsive">
				</template>
				<template v-else>
					<dropzone
						:id="'dropzone' + new Date().getTime()"
						ref="dropzone"
						:use-font-awesome="true"
						:url="dropzone.url"
						:accepted-file-types="dropzone.accepted"
						:maxFileSizeInMB="dropzone.maxFileSizeInMB"
						:maxNumberOfFiles="dropzone.maxNumberOfFiles"
						:thumbnail-height="100"
						:thumbnail-width="100"
						v-on:vdropzone-success="dropzoneSuccess"
						:headers="dropzone.headers">
					</dropzone>
				</template>
			</td>
		</tr>
	</tbody>
</template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'
	import Dropzone from 'vue2-dropzone'

	export default {
		props: ['user', 'isAuth', 'value'],
		components: {
			'loading': VueElementLoading,
			'dropzone': Dropzone
		},
		data () {
			return {
				loading: false,
				item: null,
				editMode: false,
				showImage: false,

				dropzone: {
					headers: {
						'Authorization': 'Bearer ' + this.$auth.getToken(),
						'account': this.$platform.slug,
					},
					accepted: this.$env.ACCEPTED_DROPZONE_IMAGES,
					url: null,
					maxFileSizeInMB: 20,
					maxNumberOfFiles: 1,
				},
			}
		},
		watch: {
			editMode() {
				this.$emit('editMode', this.editMode)
			}
		},
		created() {
			this.loadItem()
		},
		methods: {
			loadItem() {
				if(this.value) {
					this.item = JSON.parse(JSON.stringify(this.value))
					this.dropzone.url = process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/products/attribute/list/' + this.item.product_attribute_list_id + '/values/' + this.item.id + '/add/image'
					if(!this.item.id) {
						this.editMode = true
					}
				}
			},
			reload() {
				this.$emit('reload')
			},
			cancel() {
				this.editMode = false
				if(this.item.id) {
					this.loadItem()
				} else {
					this.$emit('remove', this.item)
				}
			},
			validate(event) {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.save()
					}
					return result
				})
			},
			save() {
				if(this.item.id) {
					this.update()
				} else {
					this.store()
				}
			},
			store () {
				this.loading = true
				this.$http.post('admin/management/products/attribute/list/values', this.item)
				.then(response => {
					this.editMode = false
					this.item = response.body.data
					this.$emit('reload')
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.loading = false
					this.$emit('reload')
				})
			},
			update () {
				this.loading = true
				this.$http.put('admin/management/products/attribute/list/values/' + this.item.id, this.item)
				.then(response => {
					this.editMode = false
					this.item = response.body.data
					this.$emit('reload')
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.loading = false
					this.$emit('reload')
				})
			},
			destroy() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/products/attribute/list/values/' + that.item.id)
							.then(response => {
								that.$emit('reload')
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			destroyImage() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.get('admin/management/products/attribute/list/values/' + that.item.id + '/destroy/image')
							.then(response => {
								that.$emit('reload')
								swal(response.body.title, response.body.text, response.body.type)
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			dropzoneSuccess(file, response) {
				this.item.image = response.path
				this.$emit('reload')
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productAttributeLists/views/Value.vue